export default __webpack_public_path__ + "static/media/warrantyManagement1.10c09f75.png";